import React from 'react';
//import PropTypes from 'prop-types';

import { getContactFieldData } from '../config';
import * as component from '../common/utils/component';
import decorate from '../common/utils/decorate';
import PhoneInput from '../common/components/PhoneInput';
import DeliveryWidgetContext from '../contexts/DeliveryWidgetContext';
import Button from '../ui/Button';
import Card from '../ui/Card';
import Grid from '../ui/Grid';
import Icon from '../ui/Icon';
import Text from '../ui/Text';
import TextInput from '../ui/TextInput';

import Query from './Query';
import AgreementList from './AgreementList';

const PhoneTextInput = React.forwardRef(
  ({ inputClassName, inputComponentRef, ...props }, ref) => (
    <TextInput
      {...props}
      className={component.className(props.className, inputClassName)}
      ref={component.ref(ref, inputComponentRef)}
    />
  )
);

export default decorate(
  class extends React.PureComponent {
    static contextType = DeliveryWidgetContext;

    static decorateWith = {};

    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
      super(props);

      this.state = {
        validate: {},
        validateNote: {},
        validateError: {},
        agreements: undefined
      };
    }

    contactsDataValidate = (field_item, value, changed) => {
      const validate = field_item.validate(value || '');

      this.setState((state) => ({
        ...state,

        validate: {
          ...state.validate,
          [field_item.name]: changed || field_item.name === 'note'
        },
        validateNote: {
          ...state.validateNote,
          [field_item.name]: validate?.note || null
        },
        validateError: {
          ...state.validateError,
          [field_item.name]: validate?.error || false
        }
      }));
    };

    renderField = (field_item) => {
      const { getAddressField, setAddressField } = this.props;

      const { langString } = this.context;

      if (!this.firstValidate) {
        setTimeout(() => {
          const value = getAddressField(field_item.name);

          this.contactsDataValidate(field_item, value, !!value);
        }, 10);
      }

      if (field_item.name === 'phone' || field_item.name === 'phone2') {
        return (
          <PhoneInput
            {...field_item.props}
            countryCallingCodeEditable
            inputComponent={PhoneTextInput}
            key={field_item.name}
            label={langString(field_item.props.label)}
            note={
              this.state.validateNote[field_item.name]
                ? langString(this.state.validateNote[field_item.name])
                : null
            }
            defaultNote={<>&nbsp;</>}
            isError={
              this.state.validate[field_item.name]
                ? this.state.validateError[field_item.name]
                : false
            }
            value={getAddressField(field_item.name) || ''}
            onChange={(value) => {
              this.contactsDataValidate(field_item, value, true);

              setAddressField(field_item.name, value);
            }}
            onBlur={(event) =>
              this.contactsDataValidate(
                field_item,
                getAddressField(field_item.name) || '',
                true
              )
            }
          />
        );
      } else {
        return (
          <TextInput
            {...field_item.props}
            key={field_item.name}
            label={langString(field_item.props.label)}
            note={
              this.state.validateNote[field_item.name]
                ? langString(this.state.validateNote[field_item.name])
                : null
            }
            isError={
              this.state.validate[field_item.name]
                ? this.state.validateError[field_item.name]
                : false
            }
            value={getAddressField(field_item.name) || ''}
            onChange={(event) => {
              const value = event.target?.value || '';

              this.contactsDataValidate(field_item, value, true);

              setAddressField(field_item.name, value);
            }}
            onBlur={(event) =>
              this.contactsDataValidate(
                field_item,
                getAddressField(field_item.name) || '',
                true
              )
            }
          />
        );
      }
    };

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const {
        isSavedAddress,

        onAgreementShow,
        onNextPage,
        onPrevPage
      } = this.props;

      const {
        cart,

        langString,

        deliveryInfo,
        method,
        company,

        isSmall
      } = this.context;

      if (!this.state.agreements)
        this.state.agreements = deliveryInfo?.agreements?.data || [];

      const nextDisabled =
        !Object.values(this.state.validateError).every((value) => !value) ||
        this.state.agreements.some((agreement) => !agreement.checked);

      const result = (
        <Query
          cart={cart}
          rightChildren={
            <>
              <AgreementList
                agreements={this.state.agreements}
                setChecked={(index, checked) => {
                  this.setState((state) => {
                    state = { ...state, agreements: [...state.agreements] };
                    
                    state.agreements[index].checked = checked;
                    
                    return state;
                  });
                }}
                onAgreementShow={onAgreementShow}
              />
              
              <Button
                variant="contained"
                disabled={nextDisabled}
                onClick={!nextDisabled ? onNextPage : null}
              >
                {langString('submit.data')}
              </Button>
            </>
          }
        >
          <Grid container>
            <Grid>
              {getContactFieldData(method, company).map(
                (data_item, data_index) => (
                  <Card key={data_index} variant="bordered">
                    <Grid container>
                      <Grid>
                        <Text strong>{langString(data_item.title)}</Text>

                        {data_item.fields.map((field_list, group_index) => (
                          <React.Fragment key={group_index}>
                            {isSmall ? (
                              <>
                                {field_list.map((field_item, field_index) =>
                                  this.renderField(field_item)
                                )}
                              </>
                            ) : (
                              <Grid container align="start">
                                {field_list.map((field_item, field_index) => (
                                  <Grid key={field_index}>
                                    {this.renderField(field_item)}
                                  </Grid>
                                ))}
                              </Grid>
                            )}
                          </React.Fragment>
                        ))}
                      </Grid>
                    </Grid>
                  </Card>
                )
              )}

              <Button variant="outlined" onClick={onPrevPage}>
                {langString(
                  isSavedAddress
                    ? 'cancel'
                    : method?.code === 'pickup'
                    ? 'point.return'
                    : 'delivery.method.return'
                )}
              </Button>
            </Grid>
          </Grid>
        </Query>
      );

      this.firstValidate = true;

      return result;
    }
  }
);
